import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const HomeComponent = lazy(() =>
  import("@/modules/home/pages/home").then((module) => ({
    default: module.Home,
  }))
);

export const Route = createFileRoute("/(auth)/_headed/home")({
  component: HomeComponent,
});
